import(/* webpackMode: "eager" */ "/app/app/(main)/deploy-demo/page.tsx");
